require(['init']);

define("main", function(){});

